/*
 * controllers/diningController.js
 * Dining Controller
 */

define('app/controllers/diningController',[
    'app/ControllerClass',
    'app/models/diningModel',
    'app/views/diningView'], function( ControllerClass, DiningModel, DiningView) {
    return window.app.controllers.diningController = $.extend({}, ControllerClass, {
        app:app,
        module: 'dining',

        actions:{
            'show':['diningBookingSelected'],
            'book':['diningBook']

        },
        init:function () {
            console.log('initializing dining controller');
            app.data.messages = app.data.messages || [];
            this._init.call(this);
        },

        diningBookingSelected:function (diningVenue,selectedDate,selectedTime,selectedCovers,selectedPromo,bookingReference) {
            var self = this;
            $.when(app.models.diningModel.getData('fetchDiningVenues', {}),
                    (app.customization.hideOtherPropertyIfItemsInCart && app.models.systemModel.validatePMSBeforeSpa()))
                .done(function (r_dv, r_pbs) {
                    if (r_dv.DiningVenues && r_dv.DiningVenues.DiningVenue) {
                        r_dv.DiningVenues.DiningVenue = $.isArray(r_dv.DiningVenues.DiningVenue) ? r_dv.DiningVenues.DiningVenue : [r_dv.DiningVenues.DiningVenue]
                        var diningVenues = r_dv.DiningVenues.DiningVenue;
                        // Dynamic restriction code for enableDiningVenues
                        if(app.customization.dynamicRestrictions && app.commonViewHelper.activeEffects.enableDiningVenues){
                            var enableDiningVenuesResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.enableDiningVenues);
                            if(enableDiningVenuesResult.isActive && enableDiningVenuesResult.value && enableDiningVenuesResult.value.length){
                                if(typeof enableDiningVenuesResult.value == 'object' && enableDiningVenuesResult.value.length && typeof enableDiningVenuesResult.value[0] == 'function'){
                                    _.each(enableDiningVenuesResult.value, function(func){
                                        diningVenues = func(diningVenues);                                    
                                    })
                                } else {
                                    diningVenues = _.filter(diningVenues, function(venue){
                                        return _.contains(enableDiningVenuesResult.value, venue.Setup.RestaurantId);
                                    });
                                }
                            }                        
                        }
                        if (diningVenues.length == 0) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                title: app.localization.dining.noLocationAccess,
                                message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                            });
                            app.dispatcher.replace('','',[]);
                            return;
                        }
                        // Dynamic restriction code for enableDiningVenues

                        if (r_pbs && app.customization.dining.PMSRoomMandatory && app.customization.dining.PMSRoomMandatory.indexOf(diningLocation.VenueName)>=0) {
                            app.data.messages.push({
                                type:'alert', 'class':'alert-info alert-no-autoclose', actions:[],
                                title:app.localization.dining.pmsbeforediningnotice
                            });
                        }
                        app.views.diningView.event.fire('requestDiningReservationSelection', [diningVenues, diningVenue,selectedDate,selectedTime,selectedCovers,selectedPromo,bookingReference]);
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.dining.errorNoLocations //,
                            //message:"("+r_ss.Result.Text+")",
                        });
                        app.dispatcher.replace('greeting','show',[])
                    }

                })
                .fail(function (r_dv) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.dining.errorNoLocations,
                        message:"("+r_ss.Result.Text+")",
                    });
                    app.dispatcher.replace('greeting','show',[])
                });
        },


        diningBook : function ( diningVenue, time, date, covers, promo, leaveConfirmed, bookingReference, specialRequests, areaId) {
            var params = {
                'AreaId':areaId == 'All' || areaId == undefined ? '': areaId,
                'PromotionId':promo||'',
                'IsLeaveTimeConfirmed':leaveConfirmed,
                'SpecialRequests':specialRequests||'',
                'PartySize':+covers,
                'VisitTime':time+':00',
                'VisitDate':date+'T'+time+':00',
                'VenueName':diningVenue
            }
            if (bookingReference) {
                params.Reference = bookingReference
                requestName = 'updateDiningReservation'
            } else {
                requestName = 'createDiningReservation'
            }
            $.when(app.models.diningModel.getData(requestName, params))
                .done(function (r_cdrr) {
                    app.commonViewHelper.updatePlaceHolderDate(date);
                    if (r_cdrr && r_cdrr.Reservation && r_cdrr.Reservation && r_cdrr.Reservation[0]  && r_cdrr.Reservation[0].Reference) {
                        app.data.messages.push({ type:'alert', 'class':'alert-success', actions:[],
                            title:app.localization.dining.successfullBookingMessage //,
                            // message:app.localization.dining.customerCustomTextFooter
                        });
                        app.dispatcher.redirect('summary','show',[]);
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.dining.errorCannotBook ,
                            message:"("+r_ss.Result.Text+")",
                        });
                        app.dispatcher.redirect('dining','show',[diningVenue,date,time,covers,promo,bookingReference])
                    }

                })
                .fail(function (r_cdrr) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.dining.errorCannotBook,
                        message:"("+r_cdrr.Result.Text+")",
                    });
                    app.dispatcher.redirect('dining','show',[diningVenue,date,time,covers,promo,bookingReference])
                });

        }
    })
});

